import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem, SelectGroup, SelectLabel } from "@/components/ui/select";
import { DialogDescription } from "@/components/ui/dialog";
import { ELEMENT_TYPES, LAYERS } from "@/constants/archimate";

export function CreateElementDialog({ open, onOpenChange, defaultLayer, onCreate }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [documentation, setDocumentation] = useState("");

  useEffect(() => {
    if (open) {
      const firstType = Object.entries(ELEMENT_TYPES).find(([, v]) => v.layer === defaultLayer)?.[0] || "";
      setType(firstType);
      setName("");
      setDocumentation("");
    }
  }, [open, defaultLayer]);

  const handleSubmit = () => {
    if (!name.trim() || !type) return;
    onCreate({ type, name: name.trim(), documentation });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="create-element-dialog">
        <DialogHeader>
          <DialogTitle>New ArchiMate Element</DialogTitle>
          <DialogDescription>Choose a layer/type and name for the new element.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs font-medium text-muted-foreground">Type</label>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger data-testid="create-element-type-select">
                <SelectValue placeholder="Select type" />
              </SelectTrigger>
              <SelectContent>
                {LAYERS.map((layer) => (
                  <SelectGroup key={layer.key}>
                    <SelectLabel>{layer.label}</SelectLabel>
                    {Object.entries(ELEMENT_TYPES)
                      .filter(([, v]) => v.layer === layer.key)
                      .map(([key, v]) => (
                        <SelectItem key={key} value={key}>
                          {v.label}
                        </SelectItem>
                      ))}
                  </SelectGroup>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground">Name</label>
            <Input data-testid="create-element-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Billing System" />
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground">Documentation</label>
            <Textarea
              data-testid="create-element-documentation-input"
              value={documentation}
              onChange={(e) => setDocumentation(e.target.value)}
              placeholder="Optional description"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="create-element-cancel-button">
            Cancel
          </Button>
          <Button onClick={handleSubmit} data-testid="create-element-submit-button">
            Create
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
